import { UTCDate } from '@/utils/dates';
import { ArrowRight } from 'lucide-react';
import { Button } from '../../../../../design-system/button/button';
import { Stack } from '../../../../../design-system/stack/stack';
import { TransactionView } from '../../../../../types/entity-types';
import { VendorTransactionTable } from '../../../../transactions/components/vendor-transaction-table';

type RecentTransactionsProps = {
  transactions: TransactionView[];
  onSelectRow?: (id: string) => void;
  onViewAll?: () => void;
};

export const RecentTransactions = ({ transactions, onSelectRow, onViewAll }: RecentTransactionsProps) => {
  const pastFiveTransactions = [...transactions]
    .sort((a, b) => new UTCDate(b.fspDate).getTime() - new UTCDate(a.fspDate).getTime())
    .slice(0, 5);

  return (
    <Stack className="w-full">
      <p className="px-4 text-base leading-[22px] font-medium tracking-[-0.02em]">Recent transactions</p>
      <VendorTransactionTable
        transactions={pastFiveTransactions}
        onSelectRow={onSelectRow}
        className="mx-auto h-full max-w-full overflow-x-clip"
      />
      <Button variant="link" className="text-link" iconRight={<ArrowRight size={16} />} onClick={onViewAll}>
        View all
      </Button>
    </Stack>
  );
};
